export const StatsSourceComponents = Object.freeze({
  SEARCH_TILE: 'search_tile',
  PRE_UNI_SEARCH_TILE: 'pre_uni_tile',
  A_TO_Z_TILE: 'A-Z_tile',
  MOST_LISTENED_SEARCH_TILE: 'most_listened_search_tile',
  RECENTLY_PLAYED_CAROUSEL: 'recently_played_carousel',
});

export const CoachmarkIds = Object.freeze({
  ALBUM_BACKSTAGE: 'album_backstage',
  ARTIST_BACKSTAGE: 'artist_backstage',
  PLAYLIST_BACKSTAGE: 'playlist_backstage',
  TRACK_BACKSTAGE: 'track_backstage',
  TRACK_SEARCH: 'track_search',
  LTUX_UPSELL: 'ltux_upsell',
  RESUME_INTERACTIVE_VIDEO: 'resume_interactive_video',
  LINKED_PLAYLIST: 'linked_playlist',
  AD_BLOCKER_DETECTED: 'ad_blocker_detected',
  PODCAST_COLLECT_NOW_PLAYING: 'podcast_collect_now_playing',
  PODCAST_FILTER: 'podcast_filter',
  TOAST_UP: 'toast_up',
  TOAST_DOWN: 'toast_down',
  AD_BLOCKER_DETECTED_WARNING_AUDIO: 'ad_blocker_detected_warning_audio',
  AD_BLOCKER_DETECTED_T1_MODAL: 'ad_blocker_detected_t1_modal',
  AD_BLOCKER_DETECTED_T1_INFOBAR: 'ad_blocker_detected_t1_infobar',
});

export const CoachmarkReasons = Object.freeze({
  UPSELL_CLICK: 'upsell_click',
  CLICK_THROUGH_ACTION_CLICKED: 'click_through_action_clicked',
  TOUCH: 'touch',
  DISMISS: 'dismiss',
  DISMISSED: 'dismissed',
  START_STATION: 'start_station',
  UPSELL: 'upsell',
  CLICK: 'click',
  UPGRADE: 'upgrade',
});
